<template>
    <div class="pop" v-show="show" @click.stop='_=>{}'>
        <div class="box">
            <div id="close" class="close_btn" v-if='closeBtn' @click="close();closeCall()"></div>
            <div class="title">{{title}}</div>
            <div class="wrap">
                <div>
                    历史数据服务只向机构销售，通过审核后签署特别合同
                    <el-form label-width="120px" size="mini" style="margin-top:20px;" :model="form">
                        <el-form-item label="机构名称">
                            <el-input v-model="form.company " placeholder="请输入机构名称"></el-input>
                        </el-form-item>
                        <el-form-item label="中基协登记编号">
                            <el-input v-model="form.zjx_no " placeholder="请输入中基协登记编号"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人姓名">
                            <el-input v-model="form.applyname " placeholder="请输入联系人姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人手机号">
                            <el-input v-model="form.tel " placeholder="请输入联系人手机号"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号验证码">
                            <el-input v-model="form.validCode " style="width:270px;margin-right:10px;" placeholder="请输入验证码"></el-input>
                            <el-button @click="getValidCode" style="width:91px;position: relative;" :style="{
                                'overflow': isValiding ? 'visible':'hidden'
                            }">{{validBtn}}
                            <div id="va" :style="{
                                opacity: isValiding ? 1 : 0,
                                right: isValiding ? 0 : 'initial',
                                left: isValiding ? 'initial' : 0
                            }"></div></el-button>
                        </el-form-item>
                        <el-form-item label="营业执照副本">
                            <el-button v-if="form.file == ''" type="primary" plain icon="el-icon-plus" @click="$refs.upload.click()"></el-button>
                            <el-image v-if="form.file != ''" style="width:80px;"  @click="$refs.upload.click()"
                            :src="form.file"
                            fit="contain"></el-image>
                            <input ref="upload" type="file" @change="importImg" style="position:absolute;opacity:0;">
                            <span style="font-size:12px;font-weight:normal;margin-left:5px;">(图片格式为：JPG/BMP/PNG/GIF,大小不超过3M)</span>
                        </el-form-item>
                        
                    </el-form>
                </div>
                <button v-if="hasBtn" class="roger btn" @click="confirm">
                    <span v-show='!loading'>提交</span>
                    <span v-show='loading'>
                        loading
                        <i class="i1"></i>
                        <i class="i2"></i>
                        <i class="i3"></i>
                    </span>
                </button>
            </div>

        </div>
    </div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'historyForm',
        data: () => ({
            show: true,
            form: {
                tel : '',
                applyname :'',
                company : '',
                validCode : '',
                zjx_no : '',
                file: ''
            },
            validBtn: '发送验证码',
            isValiding: false,
            loading: false
        }),
        props: {
            title: {
                default: '提示',
                type: String
            },
            confirmCall: {
                default: () => {},
                type: Function
            },
            hasBtn: {
                type: Boolean,
                default: true
            },
            mountHandle: {
                default: () => {},
                type: Function
            },
            closeBtn: {
                type: Boolean,
                default: false
            },
            closeCall: {
                default: () => {},
                type: Function
            },
        },
        methods: {
            confirm() {
                this.loading = true
                this.confirmCall(this.form,this.close,()=>{
                    this.loading = false
                })
            },
            close() {
                this.show = false
            },
            getValidCode () {
                if (this.validBtn != '发送验证码') return
                this.isValiding = true
                let num = 60
                let timer = setInterval(()=>{
                    if (num < 0) {
                        this.validBtn = '发送验证码'
                        clearInterval(timer)
                        return
                    }
                    this.validBtn = num + '秒后刷新'
                    num--
                },1000)
            },
            importImg (e) {
                let self = this
                let reader = new FileReader();
                reader.readAsDataURL(e.target.files[0])
                reader.onload = function (e) {
                    self.form.file = this.result

                }
            }
        },
        watch: {
            mountHandle() {
                this.$nextTick(() => {
                    this.mountHandle(this.close)
                })
            }
        },
        components: {

        },
        mounted() {
            setTimeout(()=>{
                let ic = new smartCaptcha({
                    //声明智能验证需要渲染的目标元素ID。
                    renderTo: '#va',
                    //智能验证组件的宽度。
                    width: 363,
                    // width: '100%',
                    //智能验证组件的高度。
                    //height: 42,
                    height: '100%',
                    //智能验证组件初始状态文案。
                    default_txt: '开始验证',
                    //智能验证组件验证通过状态文案。
                    success_txt: '验证成功',
                    //智能验证组件验证失败（拦截）状态文案。
                    fail_txt: '验证失败，请在此点击按钮刷新',
                    //智能验证组件验证中状态文案。
                    scaning_txt: '智能检测中',
                    //前端智能验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
                    success: (data) => {
                        this.isValiding = false
                        ic.reset()
                        if (this.form.tel  == '') {
                            return this.$market.alert({content: '手机号码不能为空'})
                        }
                        this.$axios({
                            url: "https://www.wenhua.com.cn/api/dataapi/GetMobileCode",
                            method: 'post',
                            data: {
                                phone: this.form.tel ,
                                zhlx: 9,
                                sessionid: data.sessionId,
                                token: NVC_Opt.token,
                                sig: data.sig
                            }
                        }).then(res=>{
                            if (!res.data.status) {
                                this.$market.alert({content: res.data.msg})
                            }
                        })

                    },
                    fail: function () {
                        
                    }
                });
                ic.init();
            })
        }
    }
</script>

<style scoped>
    #va {
        position: absolute;
        top: -2px;
        left: 0;
        background-color: white;
        opacity: 0;
    }
    .pop {
        position: fixed;
        z-index: 2000;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, .2);
    }

    .box {
        width: 614px;
        position: absolute;
        right: 153px;
        top: 50%;
        transform: translate(0, -50%);
    }

    .close_btn {
        width: 35px;
        height: 35px;
        position: absolute;
        right: 0;
        top: 0;
        background: url(../assets/image/close.png) no-repeat center;
        background-size: 12px;
        cursor: pointer;
    }
    .title {
        height: 34px;
        background: url(../assets/image/confirm_title_bg.jpg) repeat;
        color: #fafafa;
        font-size: 15px;
        line-height: 34px;
        padding-left: 11px;
    }

    .wrap {
        background: #fff;
        border: 1px solid #8b8b8b;
        border-top: 0;
        padding: 30px 60px;
        color: #7c7c7c;
        font-weight: bolder;
        font-size: 14px;
    }

    .roger {
        color: #fff;
        font-weight: bolder;
        background: rgb(73, 132, 212);
        padding: 5px 18px;
        cursor: pointer;
        display: block;
        width: 110px;
        zoom: 1;
        margin: 0 auto;
        border: 0;
        margin-top: 25px;
        outline: 0;
    }

    /* @media screen and (max-width: 494px) {
        .box {
            right: 50%;
            transform: translate(50%,-50%);
            width: 95%;
        }
    } */

    .btn i {
        display: inline-block;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: white;
        margin: 0 1px;
    }

    @keyframes flash1 {
        0% {
            opacity: 0;
        }

        33% {
            opacity: 1;
        }

        66% {
            opacity: 1;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes flash2 {
        0% {
            opacity: 0;
        }

        33% {
            opacity: 0;
        }

        66% {
            opacity: 1;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes flash3 {
        0% {
            opacity: 0;
        }

        33% {
            opacity: 0;
        }

        66% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    .btn .i1 {
        animation: flash1 1s ease infinite;
    }

    .btn .i2 {
        animation: flash2 1s ease infinite;
    }

    .btn .i3 {
        animation: flash3 1s ease infinite;
    }
</style>